import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const RestroomWomen = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='RestroomWomen' {...props}>
    <path fill='none' stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M7,13.5 L11,8 L12,21 M17,13.5 L13,8 L12,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L14.5,16.5 L9.5,16.5 L11,8 Z' />
  </StyledIcon>
);
